export default {
  name: "QuickActions",

  data() {
    return ({
      hover: null,
      action_items: [
        {
          label: "Create Report",
          icon: "bi bi-bar-chart-fill",
          icon_class: "text-active",
          meta: "Reports"
        },
        {
          label: "Log Maintenance",
          icon: "bi bi-wrench-adjustable",
          icon_class: "text-info-token",
          meta: "Maintenance"
        },
        {
          label: "Security Alert",
          icon: "bi bi-shield-check",
          icon_class: "text-success-token",
          meta: "Security"
        }
      ],
    });
  },
};
